import { defineStore } from 'pinia';
import $api from '@/plugins/axios';

export const useCommonStore = defineStore('CommonStore', {
  state: () => {
    return {
      pageLoaded: false,
      isHome: false,
      isAuth: false,
      isError: false,
      myInfo: null,
      sessionInfo: null,
      initialized: true,
      academiesInfo: {},
      currentPwCheck: false,
      fromUrl: '',
      openSide: true,
      selectedMenu: '',
      logoLoaded: false,
      lang: 'ko',
      studySettingInfo: {},
    };
  },
  actions: {
    /** 나의 정보(로그인세션) 반환 */
    async getProfile() {
      try {
        const info = await $api.get('/me');
        this.myInfo = info;
        return info;
      } catch (error) {
        console.log(error);
      }
    },
    /** 세션정보 반환 */
    async getSessions() {
      try {
        const sessions = await $api.get('/sessions');
        this.sessionInfo = sessions;
        if (sessions.role === 'OWNER') {
          this.initialized = sessions.initialized;
        }
        return sessions;
      } catch (error) {
        console.log(error);
      } finally {
        this.pageLoaded = true;
      }
    },
    /** 로그아웃 */
    async postLogOut() {
      try {
        await $api.post('/auth/logout');
      } catch (e) {
        this.$handleError(e);
      } finally {
        this.myInfo = null;
        this.sessionInfo = null;
        this.logoLoaded = false;
      }
    },
    /** 학원정보 조회 */
    async getAcademies() {
      try {
        const res = await $api.get('/me/academies');
        this.academiesInfo = res;
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 학원정보 수정 */
    async putAcademies(params) {
      try {
        await $api.put('/academies', params);
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 서버타임 반환 */
    async getServerTime() {
      return await $api.get(`${process.env.API_URL}/server-time`);
    },
    /** 캠스터디 유저ID에 해당하는 원생정보 반환 */
    async getCustomer(params) {
      return await $api.get(`/customers/by-user-id/${params.userId}`);
    },
    /** 캠스터디 유저ID에 해당하는 원생정보 업데이트(현재는 메모만) */
    async patchCustomer(params) {
      try {
        await $api.patch(`/customers/by-user-id/${params.customerId}`, params);
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 고객정보 수정 */
    async patchInfo(params) {
      try {
        await $api.patch(`/customers/${params.customerId}/profile`, params);
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 계정 초기화 완료 (popup안나오도록) */
    async postInitialize() {
      try {
        await $api.post(`/customers/owners/initialize`);
        this.initialized = true;
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 패스워드 동일성 체크 */
    async postPwMatch(params) {
      try {
        const res = await $api.post('/customers/password-matches', { value: params.value });
        if (res.data) {
          this.currentPwCheck = true;
        } else {
          this.currentPwCheck = false;
        }
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 이전URL저장 */
    setFromUrl(path) {
      if (path === '/auth/login') {
        return;
      }
      if (path === '/' || path.indexOf('error') !== -1 || path.indexOf('resetpw') !== -1 || path.indexOf('auth') !== -1) {
        this.fromUrl = 'dashboard';
      } else {
        this.fromUrl = path;
      }
    },
    async apiErrorTest() {
      return await $api.post('/test/error');
    },
    /** 공부 기능 설정 조회 */
    async getStudySetting(params) {
      try {
        this.studySettingInfo = await $api.get(`/groups/${params.groupId}/settings/study`);
      } catch (e) {
        this.$handleError(e);
      }
    },
    /** 공부 기능 설정 수정 */
    async changeStudySetting(params) {
      try {
        this.studySettingInfo = await $api.patch(`/groups/${params.groupId}/settings/study`, params);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    $handleError(e) {
      this.$nuxt.$sentry.captureException(e);
      this.$nuxt.error({ statusCode: e.response.status });
    },
  },
  getters: {
    getAcademiesInfo(state) {
      if (state.academiesInfo) {
        return {
          ...state.academiesInfo,
          owner: `${state.academiesInfo.ownerCustomerName}(${state.academiesInfo.ownerCustomerEmail})`,
        };
      } else {
        return;
      }
    },
  },
});
